module.exports = __webpack_public_path__ + "themify.e23a7dcaefbde4e74e26.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/themify-icons/fonts/themify.ttf
// module id = ../../../../../src/scss/icons/themify-icons/fonts/themify.ttf
// module chunks = styles